





























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { DataSource } from '@/types';
import {
    TableConfig,
    columnTemplates,
    defaultTableConfig,
} from '@/core/components/table';
import { Table } from '@/core/components/table/types';
import { localize } from '@/core/filters';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
    },
})
export default class LogTable extends Vue {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: [Array, Object], required: true })
    public dataSource!: DataSource;

    public get defaultTableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
            columnResizingMode: 'nextColumn',
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public localizeAction(rowData: any) {
        return localize(`UserActionType_${rowData.action}`);
    }
}
